<template>
        <el-select
            :value="subpropertyId"
            @change="onChange"
            placeholder
            size="large"
            style="max-width: 150px;"
            filterable
        >
            <el-option
                :key="subproperty.id"
                :label="subproperty.name"
                :value="subproperty.id"
                v-for="subproperty in subproperties"
            ></el-option>
        </el-select>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'app-subproperty-select',

    props: {
        subpropertyId: {
            type: String,
            required: true
        },

        subproperties:{ 
            type: Array,
            required: true
        },
    },

    computed: {
        ...mapGetters({
            labelPosition: 'layout/labelPosition',
            labelWidthForm: 'layout/labelWidthForm',
        }),
    },

    methods: {
        onChange(val) {
            this.$emit('update:subpropertyId', val);      
        }
    },
};
</script>
